(function () {
    'use strict';

    angular
        .module('aricModule')
        .factory('aricEnums', service);

    service.$inject = [];

    function service() {

        var service = {
            controlOwnerStatus: {
                pendingInformation: 'PendingInformation',
                readyForTesting: 'ReadyForTesting',
                testingInProgress: 'TestingInProgress',
                controlTestingToReview: 'ControlTestingToReview',
                readyForCertification: 'ReadyForCertification',
                certificationInProgress: 'CertificationInProgress',
                certificationToReview: 'CertificationToReview',
                completed: 'Completed'
            }
        };

        return service;
    }
})();